import { Package } from 'lucide-react';

interface AppealsEmptyStateProps {
  /** A filter is narrowing the list, so "nothing found" means "nothing matches". */
  filtered: boolean;
  /** Clears every filter in the panel. */
  onClear: () => void;
}

/**
 * CR-8206: what the Submitted Appeals list shows when it has no rows.
 *
 * With a filter set, it says no appeals match and offers to clear the filters,
 * rather than suggesting no appeals exist at all.
 *
 * @param filtered - Whether any filter is active
 * @param onClear - Clears the filters
 * @returns The empty-state block
 * @link AppealsSubTab
 */
export default function AppealsEmptyState({ filtered, onClear }: AppealsEmptyStateProps) {
  return (
    <div className="text-center py-12 text-muted-foreground">
      <Package className="h-12 w-12 mx-auto mb-4 opacity-50" />
      {filtered ? (
        <>
          <p>No appeals match your filters.</p>
          <button onClick={onClear} className="text-sm mt-2 underline hover:text-foreground">
            Clear all filters
          </button>
        </>
      ) : (
        <>
          <p>No delivery appeals found.</p>
          <p className="text-sm mt-2">Appeals are submitted by suppliers to dispute on-time delivery status.</p>
        </>
      )}
    </div>
  );
}
